import checkout from "./form3";

const {
  formField3: {
    companyName,
    companyTaxId,
    taxAuthorities,
    numberSupplier,
    numberSupplierAuthority,
    period,

    firstTime,
    replaceNumber,

    fullName,
    signer,
    timeSign,
    certificate,
  },
} = checkout;

const initialValues3 = {
  [fullName.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
  [certificate.name]: "",

  [companyName.name]: "",
  [companyTaxId.name]: "",
  [taxAuthorities.name]: "",
  [numberSupplier.name]: "",
  [numberSupplierAuthority.name]: "",
  [period.name]: "",
  [firstTime.name]: "",
  [replaceNumber.name]: "",
};

export default initialValues3;
